<template>
  <path
    d="M15.837 4.476a.666.666 0 00-.56-.224.677.677 0 00-.4.165L8 10.22l-6.87-5.8a.7.7 0 00-.437-.167H.635a.679.679 0 00-.464.217.633.633 0 00-.171.47.644.644 0 00.234.453l7.3 6.166.068.055.038.023.03.017a.628.628 0 00.111.047l.052.015a.3.3 0 00.066.011l.145.023v-.017h.026l.148-.025v-.009h.015a.422.422 0 00.077-.035.4.4 0 00.074-.046L15.762 5.4a.633.633 0 00.075-.919z"
  />
</template>
